import React, { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { EntityProvider } from "@/lib/entity";
import { RealtimeProvider } from "@/lib/realtime";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";
import AIPanel from "@/components/AIPanel";
import CommandPalette from "@/components/CommandPalette";

const TITLES = {
  "/app/dashboard": { title: "Tableau de bord exécutif", sub: "Vue consolidée" },
  "/app/treasury": { title: "Trésorerie", sub: "Encaissements & décaissements" },
  "/app/accounting": { title: "Comptabilité", sub: "OHADA · Journaux comptables" },
  "/app/invoices": { title: "Facturation", sub: "Factures clients" },
  "/app/hr": { title: "Ressources Humaines", sub: "Effectif & masse salariale" },
  "/app/suppliers": { title: "Fournisseurs", sub: "Annuaire fournisseurs" },
  "/app/clients": { title: "Clients", sub: "Annuaire clients" },
  "/app/purchases": { title: "Achats", sub: "Bons de commande" },
  "/app/stock": { title: "Stock", sub: "Articles en stock" },
  "/app/vehicles": { title: "Parc automobile", sub: "Véhicules du groupe" },
  "/app/maintenance": { title: "Maintenance", sub: "Interventions" },
  "/app/fuel": { title: "Carburant", sub: "Stocks stations" },
  "/app/pos": { title: "Caisse / POS", sub: "Vente en magasin" },
  "/app/chantiers": { title: "Chantiers", sub: "Projets en cours" },
  "/app/hse": { title: "HSE", sub: "Hygiène · Sécurité · Environnement" },
  "/app/epi": { title: "Dotations EPI", sub: "Équipements de protection" },
  "/app/legal": { title: "Juridique", sub: "Contrats & échéances" },
  "/app/mail": { title: "Courrier", sub: "Suivi des courriers" },
  "/app/workflows": { title: "Workflows", sub: "Demandes & validations" },
  "/app/ai-agents": { title: "Agents IA", sub: "Copilotes spécialisés" },
  "/app/users": { title: "Utilisateurs", sub: "Gestion des accès" },
  "/app/audit": { title: "Audit", sub: "Journal des actions" },
  "/app/backup": { title: "Sauvegardes", sub: "Export & import" },
  "/app/settings": { title: "Paramètres", sub: "Compte & sécurité" },
};

export default function AppLayout() {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const [aiOpen, setAiOpen] = useState(false);
  const [cmdOpen, setCmdOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") { e.preventDefault(); setCmdOpen((v) => !v); }
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "j") { e.preventDefault(); setAiOpen((v) => !v); }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  if (loading) return <div className="min-h-screen grid place-items-center bg-obsidian-950"><div className="text-obsidian-400 text-sm">Chargement…</div></div>;
  if (!user) return <Navigate to="/login" replace />;

  const meta = TITLES[loc.pathname] || { title: "", sub: "" };

  return (
    <EntityProvider>
      <RealtimeProvider>
        <div className="min-h-screen bg-obsidian-950 grain">
          <Sidebar onOpenAI={() => setAiOpen(true)} />
          <Topbar title={meta.title} subtitle={meta.sub} onOpenSearch={() => setCmdOpen(true)} />
          <main className="ml-sidebar pt-topbar min-h-screen">
            <div className="p-8 max-w-[1600px]">
              <Outlet context={{ openAI: () => setAiOpen(true) }} />
            </div>
          </main>
          <AIPanel open={aiOpen} onClose={() => setAiOpen(false)} />
          <CommandPalette open={cmdOpen} onClose={() => setCmdOpen(false)} onOpenAI={() => setAiOpen(true)} />
        </div>
      </RealtimeProvider>
    </EntityProvider>
  );
}
